// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yy92","controls":"styles_controls__ZVgoZ","charLimit":"styles_charLimit__1uXx8","input":"styles_input__pjFCH","send":"styles_send__2GE79"};